import React from 'react';
import { Avatar, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

import { eeccCategoriesMapper } from 'src/utils/eeccCategoriesMapper';


const useStyles = makeStyles(() => ({
  avatar: {
    width: '32px',
    height: '32px',
    fontSize: '1em',
    fontWeight: 'bold',
  },
}));

const CategoryEeccIcon = ({ category }) => {
  const classes = useStyles();

  if (!category) {
    return <>-</>;
  }
  const color = eeccCategoriesMapper[category].backgroundColor || eeccCategoriesMapper['DD'].backgroundColor;
  const textColor = eeccCategoriesMapper[category].textColor || eeccCategoriesMapper['DD'].textColor;
  return (
    <Avatar className={classes.avatar} style={{ backgroundColor: color, color: textColor }}>
      {category}
    </Avatar>
  );
};

CategoryEeccIcon.propTypes = {
  category: PropTypes.string,
};


export {
  CategoryEeccIcon,
};
